<div class="container-fluid" *ngIf="!isTokenVerified">
  <div class="row">
    <div class="col-lg-6 col-md-12 pl-0">
      <img class="w-100" [src]="getAssetLink('assets/img/LoginImage2.webp')" alt="Login image">
      <div class="bottom-license text-center">
        <img class="w-17-px" [src]="getAssetLink('assets/img/copyright_black_24dp.svg')" alt="Copyright image">
        <p class="d-inline m-0">    2021 Truventor AI & Robotics    |    All Rights Reserved.</p>
      </div>
    </div>
    <div class="col-lg-6 col-md-12 back-image">
      <div class="card mb-4">
        <div class="card-content">
          <div class="card-title text-center">
            <img class="h-auto" [src]="getAssetLink('assets/svg/truventor-logo-p.png')" alt="Logo">
          </div>
          <a (click)="redirectToLogin()" class="btn btn-orange mt-3 p-3 w-100">
            Log In With Truventor One
          </a>
          <a (click)="redirectToSignup()" class="btn btn-orange-outline mt-4 p-3 w-100">
            Sign Up With Truventor One
          </a>
          <a (click)="redirectOrgAdminLogin()" class="btn btn-orange-outline mb-3 mt-4 p-3 w-100">
            Organization Admin? Log In Here
          </a>
          <!-- Add the Test API Health button here -->
          <button *ngIf="showHealthCheckButton" (click)="testApiHealth()" class="btn btn-primary mt-4 p-3 w-100">
            API Check
          </button>
          <div class="text-center">
            <p class="mb-0">
              What is Truventor one? 
              <a href="https://www.truventor.com/truventorone" target="_blank">Click here to know more</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>